import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import ScanRunStateBadge from "shared/Scan/StateBadge";

import { ScanRunsListItem } from "../../../types";

const ScanRunsTableStatusCell = ({
  item: run,
  ...cellProps
}: TableSimpleCellProps<ScanRunsListItem>) => (
  <TableSimpleCell {...cellProps}>
    <ScanRunStateBadge state={run.state} />
  </TableSimpleCell>
);

export default ScanRunsTableStatusCell;
